import { render, staticRenderFns } from "./SurveysAndStatusesForSv.vue?vue&type=template&id=2b62678d&"
import script from "./SurveysAndStatusesForSv.vue?vue&type=script&lang=js&"
export * from "./SurveysAndStatusesForSv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports